import { createContext } from 'react';
import { IMiniAppContextInterface } from '../../util/Interfaces'

export default createContext<IMiniAppContextInterface>({ renderRoot: null });
